export const favoritesNotify = flag => ({
  method: flag ? 'success' : 'error',
  message: flag ? 'Круиз добавлен в корзину' : 'Круиз удален из корзины',
});
